module.exports = __webpack_public_path__ + "img/item-bg-1.6f9e8cdb.png";